<template>
  <div class="sidenav" id="left-nav" v-if="data">
    <div class="clearfix"></div>
    <!-- Landingpage -->
    <!-- <div v-if="metaRoute() && matchRoutes('landingpage')">
      <div class="links-wrapper links-wrapper-xl" v-for="(link, route) in links" :key="route">
        <router-link :to="route" :class="{ active_left: matchRoutes(route)}">
          {{link}}
        </router-link>
      </div>
    </div> -->
    <!-- Todo cascadescreening patients (gen positive) -->
    <div v-if="metaRoute() && includedScreeningLinks()">
      <div class="links-wrapper" v-for="(link, route) in screeninglinks" :key="route">
        <router-link :to="route" :class="{ active_left: matchRoutes(route)}">
          {{link}}
          <span v-if="route === 'todo'" class="badge badge-pill badge-danger">
            {{todoScreeningCounter}}
          </span>
        </router-link>
      </div>
    </div>
    <!-- Todo cascadescreening patients (gen negative) -->
    <div v-if="metaRoute() && includedGenNegativeLinks()">
      <div class="links-wrapper" v-for="(link, route) in gen_negative_links" :key="route">
        <router-link :to="route" :class="{ active_left: matchRoutes(route)}">
          {{link}}
          <span v-if="route === 'todo_gen_negative'" class="badge badge-pill badge-danger">
            {{todoGenNegScreeningCounter}}
          </span>
        </router-link>
      </div>
    </div>
    <!-- Todo cardiology patients -->
    <div v-if="metaRoute() && includedCardioLinks()">
      <div class="links-wrapper" v-for="(link, route) in cardiolinks" :key="route">
        <router-link :to="route" :class="{ active_left: matchRoutes(route)}">
          {{link}}
          <span v-if="route === 'todocardio'" class="badge badge-pill badge-danger">
            {{todoCardioCounter}}
          </span>
        </router-link>
      </div>
    </div>
    <div class="disclaimer">
      <!-- <div v-if="devQaEnv && ($route.path.includes('todo') || $route.path.includes('patient'))">
        <div class="input-group mb-3 hsa">
          <select class="form-control" v-model="hsaId">
            <option :value="null">- hsaId -</option>
            <option v-for="h in hsaIds" :value="h" :key="h">{{ h }}</option>
          </select>
          <div class="input-group-append">
            <button class="btn btn-sm hsa-btn btn-primary" type="button"
              :disabled="!hsaId" @click="devSetRegionCodeFromHsaId()">ändra</button>
          </div>
        </div>
      </div> -->
      <p class="p-env" v-if="devQaEnv && $route.path !== '/'">Miljö: {{ devQaEnv }}</p>
      <p class="p-13" v-html="clinic"></p>
      <div v-if="regionCodeFromHsaId">
        <!-- <img
          :src="require( `../assets/img/regioner/` + regionCodeFromHsaId + `/logo.svg`)"
          alt="Logotyp för tillhörande region"
          class="img-fluid img-region-logo"
        /> -->
        <img
          :src="require( `../assets/img/regioner/SE2321000016/logo.svg`)"
          alt="Logotyp för tillhörande region"
          class="img-fluid img-region-logo"
        />
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'left',
  data () {
    return {
      data: null,
      hsaId: null,
      hsaIds: [
        'SE2321000016-1111',
        'SE5565189692-2222'
      ],
      patientType: parseInt(localStorage.getItem('patientType'))
        ? parseInt(localStorage.getItem('patientType')) : null,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      todoScreeningCounter: 0,
      todoGenNegScreeningCounter: 0,
      todoCardioCounter: 0,
      clinic: '',
      pages: {
        whatisfh: 'whatisfh',
        treatfh: 'treatfh',
        aboutapp: 'aboutapp',
        helpresearch: 'helpresearch'
      },
      links: {
        todo: 'Att göra - kaskadscreening (gen positiv)',
        todo_gen_negative: 'Att göra - kaskadscreening (gen negativ)',
        todocardio: 'Att göra - kardiologpatienter'
      },
      cardiolinks: {
        todocardio: 'Att göra',
        // dashboardcardio: 'Dashboard',
        statscardio: 'Statistik',
        patientscardio: 'Alla patienter'
      },
      gen_negative_links: {
        todo_gen_negative: 'Att göra',
        stats_gen_negative: 'Statistik',
        patients_gen_negative: 'Alla patienter'
      },
      screeninglinks: {
        todo: 'Att göra',
        dashboard: 'Dashboard',
        stats: 'Statistik',
        patients: 'Alla patienter',
        indexpatients: 'Index patienter'
      },
      unauthorizedPaths: ['/error', '/errorcontent', '/'],
      hiddenScreeningRoutes: ['newidx', 'newminor', 'editidx', 'indexpatient', 'patient'],
      hiddenCardioRoutes: ['newidx', 'patientcardio', 'newcardio', 'editcardio'],
      hiddenGenNegativeRoutes: ['indexpatient_gen_negative', 'patient_gen_negative']
    }
  },
  methods: {
    todoAlert (str) {
      alert(str)
    },
    matchRoutes (route) {
      if (route) {
        return route === this.$route.path.replace('/', '')
      }
    },
    devSetRegionCodeFromHsaId () {
      if (this.hsaId) {
        // lowercase SE123 > se123 then uppercase first so: Se123 (returned from DatoCMS)
        this.hsaId = this.hsaId.substr(0, this.hsaId.indexOf('-')).toLowerCase()
        this.hsaId = this.hsaId.charAt(0).toUpperCase() + this.hsaId.slice(1)
        localStorage.setItem('regioncode', this.hsaId)
        location.reload(true)
      }
    },
    includedScreeningLinks () {
      if (this.$route) {
        const strippedPath = this.$route.path.replace(/\//g, '').replace(/[0-9]/g, '')
        if ((strippedPath in this.screeninglinks || this.hiddenScreeningRoutes.includes(strippedPath)) &&
          this.patientType === 2) {
          return true
        }
      }
    },
    includedGenNegativeLinks () {
      if (this.$route) {
        const strippedPath = this.$route.path.replace(/\//g, '').replace(/[0-9]/g, '')
        if ((strippedPath in this.gen_negative_links || this.hiddenGenNegativeRoutes.includes(strippedPath)) ||
          this.patientType === 1) {
          return true
        }
      }
    },
    includedCardioLinks () {
      if (this.$route) {
        const strippedPath = this.$route.path.replace(/\//g, '').replace(/[0-9]/g, '')
        if ((strippedPath in this.cardiolinks || this.hiddenCardioRoutes.includes(strippedPath)) &&
          this.patientType === 3) {
          return true
        }
      }
    },
    metaRoute () {
      if (this.$route.meta.showData) {
        return true
      }
      return false
    },
    async getDashboardData () {
      const screenStatusAll = 98
      axios._get(config.dashboardUri + '?ScreeningStatusType=' + screenStatusAll).then(response => {
        this.todoScreeningCounter = response.data.dashboardData.filter(ap => !ap.geneNegative).length
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get number of toDos for gene positive screening: ' + error)
        }
      })
    },
    async getGenNegDashboardData () {
      const screenStatusAll = 98
      axios._get(config.dashboardUri + '?ScreeningStatusType=' + screenStatusAll).then(response => {
        this.todoGenNegScreeningCounter = response.data.dashboardData.filter(ap => ap.geneNegative).length
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get number of toDos for gene negative screening: ' + error)
        }
      })
    },
    async getCardioDashboardData () {
      axios._get(config.cardioUri + config.dashboardUri + config.countUri).then(response => {
        if (response) {
          this.todoCardioCounter = response.data.dashboardCount
        }
      }).catch((error) => {
        if (error) {
          console.log('Could not get number of toDos for cardio: ' + error)
        }
      })
    }
  },
  computed: {
    regionCodeFromHsaId () {
      let hsa = localStorage.getItem('hsaId')
      if (hsa && hsa.includes('-')) {
        // lowercase SE123 > se123 then uppercase first so: Se123 (returned from DatoCMS)
        hsa = hsa.substr(0, hsa.indexOf('-')).toLowerCase()
        hsa = hsa.charAt(0).toUpperCase() + hsa.slice(1)
        localStorage.setItem('regioncode', hsa)
      }
      return hsa
    },
    devQaEnv () {
      if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'qa') {
        return process.env.NODE_ENV
      }
    }
  },
  async beforeMount () {
    if (!this.unauthorizedPaths.includes(this.$route.path) && localStorage.getItem('jwt') !== null) {
      await this.getDashboardData()
      await this.getGenNegDashboardData()
      await this.getCardioDashboardData()
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          clinicMisc {
            receptionlist
          }
        }
      `
    })
    if (this.metaRoute()) {
      this.clinic = localStorage.getItem('clinicName')
    }
    this.$root.$on('setClinic', (clinic) => {
      this.clinic = clinic
    })
    this.$root.$on('patientType', (pt) => {
      localStorage.setItem('patientType', pt)
      this.patientType = pt
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.hsa > select {
  font-size: 12px;
}
.hsa-btn {
  font-size: 12px;
}
.sidenav {
  height: 100%;
  width: 200px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #424346;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 6vh;
  text-align: left;
}
.sidenav a {
  padding: 15px;
  text-decoration: none;
  font-size: 15px;
  color: #fff;
  display: block;
  transition: 0.3s;
}
.sidenav a:hover {
  color: #DEDEDE;
}
.disclaimer {
  position: absolute;
  color: #EEEEEE;
  bottom: 1vh;
  font-size: .8rem;
  line-height: 2vh;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 0.7vw;
  margin-right: 0.4vw;
}
.links-wrapper-xl a {
  font-size: 111% !important;
}
.img-region-logo {
  zoom: 1.4;
}
.p-env {
  font-size: 12px;
  color: rgb(44, 41, 44);
  background: #fff;
  padding: 8px;
  width: auto;
  border-radius: 5px;
}
.p-13 {
  font-size: 13px !important;
}
.badge {
  float: right;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
    #left-nav {
      width: 19vw !important;
    }
    #left-nav a, p {
      font-size: .5rem !important;
    }
    .badge {
      padding: .2rem;
    }
    .disclaimer {
      display: none;
    }
}
@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}
@media screen and (max-width: 550px) {
  .sidenav {width: 0 !important;}
}
@media screen and (min-width: 1900px) {
  .sidenav {width: 12rem;}
  .disclaimer {padding-left: 0;}
}
</style>



// WEBPACK FOOTER //
// src/components/Left.vue